import {
  CustomerSigner,
  DocumentSignatureStatus,
  DocumentType,
  PaymentType,
  ProjectType,
  SettingKey,
  SupplierCategory,
  UserType,
  VATRate,
} from '@bulthaup/api/db';

export const label = (
  key:
    | null
    | UserType
    | ProjectType
    | DocumentType
    | SettingKey
    | CustomerSigner
    | DocumentSignatureStatus
    | PaymentType
    | VATRate
    | SupplierCategory
    | 'CREATED'
    | 'SIGNED'
    | 'NOT_CREATED',
) => {
  switch (key) {
    case UserType.ADMIN:
      return 'Administrateur';
    case UserType.TECHNICIAN:
      return 'Technicien';
    case UserType.SELLER:
      return 'Concepteur';
    case UserType.INSTALLER:
      return 'Poseur';
    case ProjectType.KITCHEN:
      return 'Cuisine';
    case ProjectType.COMPLEMENT:
      return 'Complément';
    case ProjectType.AFTER_SALES:
      return 'SAV';
    case ProjectType.ACCESSORY:
      return 'Accessoire';
    case DocumentType.QUOTE:
      return 'Marché';
    case DocumentType.TECHNICAL_PLAN:
      return 'Plan technique';
    case DocumentType.INITIAL_DEPOSIT_INVOICE:
      return "Facture d'acompte initial";
    case DocumentType.ON_DELIVERY_DEPOSIT_INVOICE:
      return "Facture d'acompte à la livraison";
    case DocumentType.FINAL_INVOICE:
      return 'Facture finale';
    case SettingKey.SUPPLIERS:
      return 'Fournisseurs';
    case SettingKey.ITEM_NAMES:
      return 'Désignations';
    case SettingKey.BULTHAUP_LINES:
      return 'Lignes Bulthaup';
    case SettingKey.BULTHAUP_PROGRAMS:
      return 'Programmes Bulthaup';
    case SettingKey.BULTHAUP_COLORS:
      return 'Coloris Bulthaup';
    case SettingKey.WORKTOP:
      return 'Plan de travail';
    case SettingKey.SPLASHBACK:
      return 'Crédence';
    case SettingKey.CUSTOMER_TITLES:
      return 'Civilités';
    case CustomerSigner.CLIENT1:
      return 'Client 1';
    case CustomerSigner.CLIENT2:
      return 'Client 2';
    case DocumentSignatureStatus.DONE:
      return 'Signé';
    case DocumentSignatureStatus.ONGOING:
      return 'En attente de signature';
    case DocumentSignatureStatus.DECLINED:
      return 'Décliné';
    case DocumentSignatureStatus.REJECTED:
      return 'Rejeté';
    case DocumentSignatureStatus.CANCELED:
      return 'Annulé';
    case DocumentSignatureStatus.EXPIRED:
      return 'Expiré';
    case DocumentSignatureStatus.DRAFT:
      return 'Brouillon';
    case PaymentType.ON_ORDER:
      return 'Acompte Commande';
    case PaymentType.ON_DELIVERY:
      return 'Acompte Livraison';
    case PaymentType.FINAL:
      return 'Solde';
    case VATRate.TWENTY_PERCENT:
      return '20%';
    case VATRate.TEN_PERCENT:
      return '10%';
    case VATRate.EIGHT_PERCENT:
      return '8%';
    case VATRate.FOREIGN:
      return 'Étranger';
    case SupplierCategory.BULTHAUP:
      return 'Bulthaup';
    case SupplierCategory.SANITARY:
      return 'Sanitaire';
    case SupplierCategory.APPLIANCE:
      return 'Électroménager';
    case SupplierCategory.FURNITURE:
      return 'Plan de travail';
    case SupplierCategory.CARRIER:
      return 'Transporteur';
    case SupplierCategory.INSTALLER:
      return 'Installateur';
    case SupplierCategory.MEUBLE:
      return 'Meuble';
    case SupplierCategory.DECORATION:
      return 'Décoration';
    case SupplierCategory.WORKS:
      return 'Travaux';
    case 'CREATED':
      return 'Envoyé';
    case 'SIGNED':
      return 'Signé';
    case 'NOT_CREATED':
      return '';
    default:
      return key;
  }
};
